import { ref, type Ref, onMounted } from 'vue';
import { useApplicationStore } from "@/stores/Application";
import { useNuxtApp } from '#app';
import { DebugSettings } from '@ca.vmedia.tv/domains';
import type { TDevModeSettingsValue } from "@/common/types/dev-mode";

export interface IUseDevModeSettings {
    debugSetting: Ref<DebugSettings | null>;
    saveSettings: () => void;
    setSettings: (key: keyof DebugSettings, value: TDevModeSettingsValue) => void;
}

export const useDevModeSettings = (): IUseDevModeSettings => {
    const app = useNuxtApp();
    
    const debugSetting: Ref<DebugSettings | null> = ref(null)
    
    const setSettings = (key: keyof DebugSettings, value: TDevModeSettingsValue): void => {
        debugSetting.value = {
            ...debugSetting.value!,
            [key]: value
        };
    };
    
    const saveSettings = (): void => {
        const oldSettings = JSON.stringify(app.$domains.lsCacher.get('debug-settings'));
        const newSettings = JSON.stringify(debugSetting.value);
        if (oldSettings === newSettings) {
            throw new Error();
        }
        app.$domains.lsCacher.put('debug-settings', new DebugSettings({
            ...debugSetting.value,
        }));
        const ApplicationStore = useApplicationStore();
        const { openModalReloadApp } = ApplicationStore;
        openModalReloadApp();
    };
    onMounted(() => {
        debugSetting.value = app.$domains.lsCacher.get('debug-settings');
    })
    return { debugSetting, setSettings, saveSettings }
}